exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3hJzT-7_3_0 {\n  font-size: 20px;\n  font-weight: 700; }\n\n._2SVZL-7_3_0 {\n  font-size: 30px;\n  font-weight: 200; }\n\n._3KuMk-7_3_0 {\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase; }\n\n._2Uvac-7_3_0 {\n  font-size: 15px;\n  font-weight: 500; }\n\n._1YRah-7_3_0 {\n  font-size: 13px;\n  font-weight: 400; }\n\n._1wCRh-7_3_0 {\n  font-size: 13px;\n  font-weight: 700; }\n\n.eLs10-7_3_0 {\n  font-size: 13px;\n  font-weight: 400; }\n\n._2phZE-7_3_0 {\n  font-size: 13px;\n  font-weight: 700; }\n\n._25phy-7_3_0 {\n  font-size: 11px;\n  font-weight: 400; }\n\n._3Jgs0-7_3_0 {\n  font-size: 11px;\n  font-weight: 700; }\n\n._3kocd-7_3_0 {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: italic; }\n\n._1s08K-7_3_0 {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: italic;\n  color: #000000; }\n  ._24n1j-7_3_0 {\n    color: #f47e42; }\n  ._2ynYi-7_3_0 {\n    color: #d62c2f; }\n  ._3YZjY-7_3_0 {\n    font-size: 12px;\n    color: #707070; }\n", ""]);

// Exports
exports.locals = {
	"core-font-tool-header": "_3hJzT-7_3_0",
	"core-font-h1": "_2SVZL-7_3_0",
	"core-font-h2": "_3KuMk-7_3_0",
	"core-font-h3": "_2Uvac-7_3_0",
	"core-font-form-value": "_1YRah-7_3_0",
	"core-font-form-key": "_1wCRh-7_3_0",
	"core-font-table-value--lg": "eLs10-7_3_0",
	"core-font-table-header--lg": "_2phZE-7_3_0",
	"core-font-table-value--sm": "_25phy-7_3_0",
	"core-font-table-header--sm": "_3Jgs0-7_3_0",
	"core-font-notation": "_3kocd-7_3_0",
	"core-notation": "_1s08K-7_3_0",
	"core-notation--required": "_24n1j-7_3_0",
	"core-notation--error": "_2ynYi-7_3_0",
	"core-notation--pagination": "_3YZjY-7_3_0"
};